export default {
  title: 'Storefront',
  fields: {
    has_reservations: {
      label: 'Näytä varaukset Storefrontissa',
    },
  },
  button: {
    save: 'Tallenna',
    preview: 'Esikatsele',
  },
  no_storefront: {
    title: 'Storefrontia ei löytynyt',
    description: 'Luo Storefront.',
    button: {
      storefront: 'Siirry Storefrontiin',
    },
  },
  response_messages: {
    success: 'Päivitetty onnistuneesti.',
    failed: 'Päivitys epäonnistui.',
  },
};
